fx.translations("de",{
    "Sauvegarde de votre mise en page ..." : "Speichern Ihres Layouts ...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "HEIC-Bilder müssen vollständig heruntergeladen werden, um für die automatische Erstellung verwendet zu werden.",

    "Aller à votre album" : "Zu Ihrem Album",
    "Choisissez votre album en fonction de votre budget" : "Wählen Sie Ihr Album nach Ihrem Budget",
    "Cliquez pour voir les détails" : "Klicken Sie, um die Details anzuzeigen",
    "Pour ajouter une Photo" : "Um ein Foto hinzuzufügen",
    "Déplacez une photo depuis la galerie" : "Ziehen Sie ein Foto aus der Galerie",
    "Sélectionnez au minimum une trentaine de photos" : "Wählen Sie mindestens etwa dreißig Fotos"
});

